/**
 * @description question-list model
 * @date 2019-03-29
 * @author jywang
 */
import React, { Component } from 'react';
import { DatePicker, Pagination } from 'antd';
import UnitLi from './component/unit-li';
import { QuestionUnitLi } from './component/question-unit-li';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react/custom';
import moment from 'moment';
import toast from '@util/toast';
import './index.scss';
const tabList = [{ status: 0, text: '全部' }, { status: 2, text: '已发布' }, { status: 1, text: '审核中' }, { status: 3, text: '未通过' }];
const { RangePicker } = DatePicker;
@inject('store')
@observer
class QuestionList extends Component<any, any> {
    public searchParam: any = {};
    constructor(props) {
        super(props);
        this.init();
    }
    public init = () => {
        this.state = {
            tabindex: 0,
        };
    }
    public componentWillMount() {
        this.props.store.hasLoginManage();
        this.getList();
    }
    public render() {
        const { tabindex } = this.state;
        const { store } = this.props;
        const { myQuestionList } = store;
        return (
            <div className="question-box">
                <nav className="tabCon">
                    <div className="tabBox">
                        问答动态
                        <div className="tabList">
                            {
                                tabList.map((item, idx) => {
                                    // tslint:disable-next-line: jsx-no-lambda
                                    return <span key={idx} className={tabindex === idx ? 'active' : ''} onClick={() => this.tabSwitch(idx, item.status)}>{item.text}</span>;
                                })
                            }
                        </div>
                    </div>
                    <div className="tabBox">
                        时间选择
                        <div className="date-box">
                            <RangePicker onChange={this.onChange} />
                        </div>
                    </div>
                </nav>
                <div className="question-li-box">
                    <ul hidden={myQuestionList.results.length <= 0}>
                        {
                            myQuestionList.results.length > 0 && myQuestionList.results.map((item, idx) => {
                                const liItem = item.type === 8 || item.type === 9 ? <li key={idx}>< UnitLi questionProductId={item.questionProductId} auditDescription={item.auditDescription} status={item.status} delQuestion={this.delQuestion} shareSum={item.shareSum} commentSum={item.commentSum} favourSum={item.favourSum} browseSum={item.browseSum} description={item.description} avatar={item.avatar} nickname={item.nickname} imageUrls={item.images} surfacePlot={item.surfacePlot} title={item.title} answerSum={item.answerSum} collectSum={item.collectSum} releaseTime={moment(item.releaseTime).format('YYYY-MM-DD HH:mm:ss')} id={item.id} /></li> :
                                    item.type === 6 || item.type === 7 ? <li key={idx}>< QuestionUnitLi checkAnswer={this.checkAnswer} questionProductId={item.questionProductId} auditDescription={item.auditDescription} status={item.status} delQuestion={this.delQuestion} imageUrls={item.images} surfacePlot={item.surfacePlot} title={item.title} answerSum={item.answerSum} collectSum={item.collectSum} releaseTime={moment(item.releaseTime).format('YYYY-MM-DD HH:mm:ss')} id={item.id} /></li> : null;
                                return liItem;
                            })
                        }
                    </ul>
                    <p hidden={myQuestionList.dataStatus !== 'done' || myQuestionList.dataStatus === 'done' && myQuestionList.results && myQuestionList.results.length > 0} className="no-data">暂无数据</p>
                    <p hidden={myQuestionList.dataStatus !== 'pending'} className="no-data">加载数据中...</p>
                </div>
                <div className="page-box">
                    <Pagination size="small" onShowSizeChange={this.onShowSizeChange} onChange={this.pageChange} defaultCurrent={myQuestionList.pageNo} defaultPageSize={myQuestionList.pageSize} total={myQuestionList.totalCount} showSizeChanger={true} showQuickJumper={true} />
                </div>
            </div>
        );
    }
    public onChange = (date, dateString) => {
        console.log(date, dateString);
        if (date[0] && date[1]) {
            const startDate = moment(date[0]).format('YYYY-MM-DD') + ' 00:00:00';
            const endDate = moment(date[1]).format('YYYY-MM-DD') + ' 23:59:59';
            const dateAtMix = moment(startDate).format();
            const dateAtMax = moment(endDate).format();
            const info: any = {};
            info.dateStart = dateAtMix;
            info.dateEnd = dateAtMax;
            info.pageNo = 1;
            info.pageSize = 10;
            this.getList(info);
        } else {
            delete this.searchParam.dateStart;
            delete this.searchParam.dateEnd;
            this.searchParam.pageNo = 1;
            this.searchParam.pageSize = 10;
            this.getList(this.searchParam);
        }

    }
    public pageChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getList(info);
    }
    public onShowSizeChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getList(info);
    }
    public tabSwitch = (index, status) => {
        this.setState({
            tabindex: index,
        });
        const info: any = {};
        info.status = status;
        info.pageNo = 1;
        info.pageSize = 10;
        this.getList(info);
    }
    public getList = (param: any = {}) => {
        const info: any = {};
        info.pageNo = 1;
        info.pageSize = 10;
        this.searchParam = Object.assign(info, this.searchParam, param);
        this.props.store.myQuestionList.get(this.searchParam);
    }
    public delQuestion = (id) => {
        this.props.store.getDetail.del(id, () => {
            toast.error('删除成功');
            this.getList(this.searchParam);
        }).catch((err) => {
            toast.error('删除失败');
        });
    }
    public checkAnswer = (id, questionProductId) => {
        const { answerList } = this.props.store;
        id = questionProductId || id;  // 如果questionProductId存在就使用，因为可能当前是答案详情
        answerList.checkAnswer(id).then((res) => {
            if (res) {
                window.location.href = `/question/response/${id}`;
            } else {
                toast.warning('该问题您已回答过');
            }
        }).catch((err) => {
            toast.error(err.msg);
        });
    }
}
export default QuestionList;
